// Multi-selection filter types
export interface ArtistMultiFilters {
  searchQuery: string;
  genres: string[];
  distance: string;
  countries: string[];
  monthlyListenersBucket: string;
  skills: string[];
}

export const DEFAULT_MULTI_FILTERS: ArtistMultiFilters = {
  searchQuery: '',
  genres: ['all'],
  distance: 'all',
  countries: ['all'],
  monthlyListenersBucket: 'all',
  skills: ['all'],
};

export type MultiFilterKey = keyof ArtistMultiFilters;

// Helper function to check if a filter matches "all"
export const isAllSelected = (values: string[]): boolean => {
  return values.includes('all') || values.length === 0;
};

// Helper function to check if an item matches the filter
export const matchesMultiFilter = (
  itemValues: string | string[] | null | undefined,
  filterValues: string[]
): boolean => {
  if (isAllSelected(filterValues)) return true;

  if (!itemValues) return false;

  // Convert to array for consistent handling
  const values = Array.isArray(itemValues) ? itemValues : [itemValues];

  // Check if any filter value matches any item value
  return filterValues.some((filterValue) =>
    values.some((value) => value.toLowerCase().includes(filterValue.toLowerCase()))
  );
};
